module.exports = __webpack_public_path__ + "img/img2.1945d327.png";